// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"4d82362e","726":"2adb63b2"}[chunkId] + ".chunk.js";
};